<template>
    <div>
        <el-dialog
            :title="title"
            :visible.sync="showdialog"
            width="90%"
            :before-close="back">
            <div class="warp">
                <div class="table-box">
                    <el-table :data="tabledata" border stripe size="mini" v-loading="loading">
                        <el-table-column type="index" label="序号" width="50"></el-table-column>
                        <el-table-column prop="city" label="城市" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="district" label="行政区" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="police" label="派出所" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="community" label="社区" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="user.name" label="用户" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="house.BZDZ" label="地址" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="add_time" label="巡查时间" show-overflow-tooltip></el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    small
                    :total="total" background>
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showdialog: true,
            tabledata: [],
            pageNo: 0,
            pagesize: 15,
            total: 0,
            loading: false,
            dates: [],
            item: {},
            title: '巡查记录',
        }
    },
    mounted () {
        let {item, dates} = this.$route.query;
        this.item = JSON.parse(item);
        this.dates = JSON.parse(dates);
        this.title = '巡查记录-'+this.item[this.item.mode];
        this.gettabledata();
    },
    methods: {
        back() {
            this.$router.go(-1)
        },
        currentChange(page) {
            this.pageNo = page-1;
            this.gettabledata();
        },
        gettabledata() {
            var params = {
                city: this.item.city,
                district: this.item.district,
                police: this.item.police,
                community: this.item.community,
                dates: JSON.stringify(this.dates),
                pageNo: this.pageNo,
                pagesize: this.pagesize,
            }
            this.loading = true;
            this.$api.getPatrolList(params)
            .then(data=>{
                this.loading = false;
                let {total, list} = data;

                this.total = total;
                this.tabledata = list;
            })
        },
    },
}
</script>

<style lang="scss" scoped>

</style>